export const contactsConstants = {
    CONTACTS_FETCH: 'CONTACTS_FETCH',
    CONTACTS_SUCCESS: 'CONTACTS_SUCCESS',
    CONTACTS_ERROR: 'CONTACTS_ERROR',
    SET_CONTACTS: 'SET_CONTACTS',
    RESET_CONTACTS: 'RESET_CONTACTS',
    SEARCHED_CONTACTS_SUCCESS: 'SEARCHED_CONTACTS_SUCCESS',
    SEARCHED_CONTACTS_RESET: 'SEARCHED_CONTACTS_RESET',
    BULK_EDIT_DATA_SUCCESS: 'BULK_EDIT_DATA_SUCCESS',
    SET_CONTACT_LOADING: 'SET_CONTACT_LOADING',
    SET_CONTACT: 'SET_CONTACT',
    SET_CONTACT_DRAWER: 'SET_CONTACT_DRAWER',
    SET_CONTACT_DELETE_MODAL: 'SET_CONTACT_DELETE_MODAL',
    SET_CONTACT_EDIT_MODAL: 'SET_CONTACT_EDIT_MODAL',
    SET_CONTACT_MERGE_MODAL: 'SET_CONTACT_MERGE_MODAL',
    SET_CONTACT_INIT_CONVERSATION_MODAL: 'SET_CONTACT_INIT_CONVERSATION_MODAL',
};
